import { SafePromise } from '@benzinga/safe-await';
import { RestfulClient, Session } from '@benzinga/session';
import { Geo } from './entities';
import { GeoEnvironment } from './environment';

export class GeoRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(GeoEnvironment).url, session);
  }

  getGeoLocation = (): SafePromise<Geo> => {
    const url = this.URL('https://get.geojs.io/v1/ip/geo.json');
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  getZipCode = (city: string, region: string): SafePromise<any> => {
    const url = this.URL(`geo/zip-codes?city=${city}&state=${region}`);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
